import React, { useState, useEffect, useRef } from 'react'
import HStack from './HStack'
import VStack from './VStack'
import RStack from './RStack'

import { ReactComponent as FBIcon } from './images/facebook.svg'
import Data from './data/Data'
import logo from './images/accma_logo.webp'

const theme = Data.theme

const componentStyles = {
    small: {
        container: { root: { padding: 0, alignItems: 'center' } },
        imageContainer: { root: { padding: '40px 20px 20px', justifyContent: 'center', alignItems: 'center'} },
        iconContainer: { root: { padding: '20px 20px', justifyContent: 'center', alignItems: 'center'} },
        copyrightContainer: { root: { padding: '10px', alignItems: 'center', fontSize: 11} }
    },
    medium: {
        container: { root: { padding: 0 } },
        imageContainer: { root: { padding: '40px 20px 20px', width: 300} },
        iconContainer: { root: { padding: '40px 20px 20px', justifyContent: 'end', alignItems: 'center'} },
        copyrightContainer: { root: { padding: '10px', alignItems: 'center', fontSize: 12} }
    },
    large: {
        container: { root: { padding: 0, alignItems: 'center', justifyContent: 'center' } },
        imageContainer: { root: { padding: '40px 20px 20px', width: 400 } },
        iconContainer: { root: { padding: '40px 20px 20px', justifyContent: 'end', alignItems: 'center'} },
        copyrightContainer: { root: { padding: '10px 10px 10px', alignItems: 'center', fontSize: 14} }
    },
}

export default function Footer(props) {
    const {
        size = 'large',
    } = props

    const cStyles = componentStyles[size] ?? {}

    return (
        <>
            <RStack size={size}  styles={cStyles.container}>
                <HStack grow={0} styles={cStyles.imageContainer}>
                    <img src={logo} alt='logo' style={{ objectFitt: 'cover', borderRadius: 10, width: '100%', height: '100%' }} />
                </HStack>
                <HStack grow={1} styles={cStyles.iconContainer}>
                {/* <a href="https://www.facebook.com/DrDarrenCarpenter/" target="_blank" class="w3-bar-item"><i
                    class="fa fa-facebook-official w3-hover-opacity" style="font-size: 48px;"></i></a> */}
                    <VStack styles={{root:{alignItems: 'center'}}}>
                    {/* <FBIcon style={{ width: 36, height: 36, fill: 'white', margin: '5px 15px' }} /> */}
                    </VStack>
                </HStack>
            </RStack>
            <VStack styles={cStyles.copyrightContainer}>
                <span style={{color: 'white'}}>Copyright © 2023 African Centre of Chinese Medicine an Acupunture</span>
            </VStack>
        </>
    )
}